import { render } from "./SidebarLink.vue?vue&type=template&id=8ab57b8a&scoped=true"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"

import "./SidebarLink.vue?vue&type=style&index=0&id=8ab57b8a&scoped=true&lang=scss"

import exportComponent from "D:\\repos\\multihabit-webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab57b8a"]])

export default __exports__